// extracted by mini-css-extract-plugin
export default {"iconWrapper":"MoreActionsButton_iconWrapper__yrUHi","icon":"MoreActionsButton_icon__syYfi","dropdown":"MoreActionsButton_dropdown__ODzJo","arrow":"MoreActionsButton_arrow__ayYDq"};